{
    "accept": "Hyväksy",
    "action_open_in_external_app": "Avaa ${1}",
    "all": "Kaikki",
    "apply": "Hae",
    "back": "Takaisin",
    "cancel": "Peruuta",
    "choose": "Valitse",
    "clear": "Tyhjennä",
    "clear_all": "Tyhjennä kaikki",
    "clear_filters": "Tyhjennä suodattimet",
    "client_offline_error_description": "Olet offline-tilassa. Tarkista internet-yhteytesi ja yritä uudelleen.",
    "client_offline_error_title": "Ei Internet-yhteyttä",
    "client_timeout_error_description": "Emme voineet suorittaa pyyntöäsi loppuun yhteyden aikakatkaisun vuoksi. Tarkista yhteys ja yritä uudelleen. Jos ongelma jatkuu, tukitiimimme auttaa sinua.",
    "client_timeout_error_title": "Yhteys on päättynyt.",
    "content_missing": "Sisältö puuttuu.",
    "delete": "Poista",
    "description": "Kuvaus",
    "dismiss": "Hylkää",
    "done": "Valmis",
    "donor_feedback_anonymized": "Olemme jo anonymisoineet tietosi tietosuojasyistä.",
    "donor_feedback_incorrect_link": "Käyttämäsi linkki ei ole oikea - varmista, että käytät täydellistä linkkiä, joka on lähetetty sinulle.",
    "donor_feedback_not_found": "Valitettavasti tämä linkki on virheellinen, mikä voi johtua jostain seuraavista syistä:",
    "error_occurred": "Tapahtui virhe",
    "expired": "Vanhentunut",
    "failed": "Epäonnistunut",
    "field_address_search_accuracy_hint": "Paranna hakutuloksia antamalla sovellukselle pääsy sijaintiisi käyttöjärjestelmän asetusten kautta.",
    "field_error_address_unsupported_country": "Osoite ei ole tuetussa maassa",
    "field_error_any": "Ilmoita vähintään yksi seuraavista kentistä: ${1}",
    "field_error_date_invalid": "Anna oikea päivämäärä",
    "field_error_date_max": "Päivämäärän on oltava ${1} tai sitä aikaisempi.",
    "field_error_date_min": "Päivämäärän on oltava ${1} tai sen jälkeen.",
    "field_error_date_range_max": "Päivämäärän on oltava ennen ${1}",
    "field_error_date_range_min": "Päivämäärän on oltava ${1} jälkeen",
    "field_error_email": "Anna oikea sähköpostiosoite",
    "field_error_length_max": "Tämä kenttä on rajoitettu ${1} merkkeihin.",
    "field_error_length_min": "Anna vähintään ${1} merkkiä.",
    "field_error_max": "Suurin arvo on ${1}",
    "field_error_min": "Pienin arvo on ${1}",
    "field_error_pattern": "Syöttö on virheellinen",
    "field_error_phone_invalid": "Anna voimassa oleva puhelinnumero",
    "field_error_phone_starts_with_zero": "Maakoodi on jo olemassa. Poista puhelinnumerosta etumerkki \"0\".",
    "field_error_required": "Täytä tämä kenttä",
    "field_is_required": "Tämä kenttä on pakollinen",
    "field_placeholder_address_search": "Kirjoita sijainti",
    "field_select_not_found": "${1}' ei löytynyt.",
    "font_big": "iso fontti",
    "font_medium": "keskikokoinen fontti",
    "font_small": "pieni fontti",
    "last_attempt": "Viimeinen yritys",
    "last_upload": "Viimeisin lataus",
    "link_sent": "Linkki lähetetty, tarkista",
    "network_error": "Verkkovirhe",
    "network_error_cookies_disabled_description": "Näyttää siltä, että olet poistanut kaikki evästeet käytöstä? Ehkä kokeile toista selainta",
    "network_error_cookies_disabled_title": "Evästeet pois käytöstä",
    "next": "Seuraava",
    "no_results": "Ei tuloksia",
    "offline": "offline",
    "ok": "OK",
    "online": "online",
    "open": "Avaa",
    "page_not_found_description": "Sivua, jota yritit hakea, ei ole olemassa. Olet ehkä kirjoittanut URL-osoitteen väärin.",
    "page_not_found_link": "Palaa etusivulle.",
    "page_not_found_title": "Sivua ei löydy",
    "pagination_result": "${1} - ${2} of ${3} Tulokset",
    "passed": "Hyväksytty",
    "request_support": "Pyydä tukea",
    "request_support_error_title": "Pyyntö epäonnistui",
    "request_support_success_description": "Saimme tukipyyntösi.",
    "request_support_success_title": "Vastaanotettu pyyntö",
    "reset_filters_description": "Kokeile säätää hakua tai suodattimia.",
    "result": "Tulos",
    "retry": "Yrityä uudelleen",
    "save": "Tallenna",
    "select_group_selected": "Valitut",
    "send_a_support_request": "Tukipyyntö",
    "server_unavailable_error_description": "Palvelu ei ole tilapäisesti käytettävissä. Tarkista myöhemmin uudelleen.",
    "server_unavailable_error_title": "Palvelu ei ole käytettävissä",
    "server_unexpected_error_description": "Jokin meni pieleen meidän puoleltamme. Yritä hetken kuluttua uudelleen. Jos ongelma jatkuu, ota yhteyttä asiakaspalveluumme.",
    "server_unexpected_error_title": "Tapahtui odottamaton virhe.",
    "state_done": "Valmis",
    "state_not_uploaded": "Ei ladattu",
    "state_pending": "Vireillä",
    "state_refused": "Kieltäytyi",
    "state_uploading": "Lataa",
    "submit": "Lähetä",
    "support_request_type": "Tyyppi",
    "support_request_type_crash": "Crash",
    "support_request_type_critical": "Kriittinen",
    "support_request_type_minor": "Pieni asia",
    "support_request_type_other": "Muut tiedot",
    "toggle_detail_view": "Yksityiskohtainen näkymä",
    "toggle_list_view": "Luettelonäkymä",
    "type": "Tyyppi",
    "unknown_error": "Jokin meni pieleen",
    "unknown_error_description": "Tapahtui odottamaton virhe. Yritä uudelleen. Jos ongelma jatkuu, ota yhteyttä asiakaspalveluun.",
    "uploading": "Lataa...",
    "validating": "Hetkinen, varmistamme, että kaikki on oikein..."
}